module.exports = __webpack_public_path__ + "static/koenigsberg-bridges-8829125c14c10756b78ce69a24035f0e.png";